import type { ApiErrorResponse } from '@libs/data-access/queries'
import { AlertErrorAdapter, Center, Loader } from '@libs/ui/ds'
import type { UseQueryResult } from '@tanstack/react-query'
import type { FC } from 'react'
import React from 'react'

type Props = {
  status?: UseQueryResult['status']
  error?: ApiErrorResponse | null
  className?: string
  overlay?: boolean
}

export const QueryRequestStatus: FC<Props> = ({
  overlay,
  status,
  error,
  className
}) => {
  if (status === 'pending') {
    return overlay ? (
      <Loader.Overlay className={className} />
    ) : (
      <Center className={`h-full ${className}`}>
        <Loader className={className} />
      </Center>
    )
  }

  if (status === 'error') {
    return <AlertErrorAdapter className={className} error={error?.error} />
  }

  return null
}
